const drawerWidth = 260;

const styles = theme => {
  const small_up = theme.breakpoints.up("md");
  const small_down = theme.breakpoints.down("md");
  const rootPaper = {};
  rootPaper[small_up] = { padding: '2%' };
  rootPaper[small_down] = {
    "@media print":{
    padding: '0'
    },
    padding: "4%"
  };
  return {
    root: {
      flexGrow: 1,
      zIndex: 1,
      position: "relative",
      display: "flex",
      "@media print": {
        border: "none",
        boxShadow: "none"
      }
    },
    blocked:{
      opacity: 0
    },
    appBar: {
      position: "fixed",
      "@media print": {
        display: "none"
      },
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    appBarShift: {
      marginLeft: drawerWidth,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    menuButton: {
      marginLeft: 12,
      marginRight: 36,
      minHeight: 48,
      "@media (max-width: 600px)": {
        margin: 0,
      },
    },
    hide: {
      display: "none"
    },
    drawerPaper: {
      "@media print": {
        display: "none"
      },
      position: "fixed",
      width: drawerWidth,
      //if you remove this, the close/open animations gonna bounce around
      whiteSpace: "nowrap",
      overflow: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      }),
      height: '100%'
    },
    drawerPaperSm: {
      width: 0
    },
    drawerPaperMd: {
      width: 70
    },
    drawerPaperClose: {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: "0 8px",
      ...theme.mixins.toolbar
    },
    content: {
      flexGrow: 1,
      width: "20%",
      backgroundColor: theme.palette.background.default
    },
    rootPaper: rootPaper,
    flex: {
      flex: 1
    },
    hiddenPaper: {
      backgroundColor: 'inherit',
      boxShadow: "none",
      textAlign: "center"
    },

    "@media print": {
      border: "none",
      boxShadow: "none"
    },
    empty_table: {
      marginTop: "30px",
      textAlign: "center"
    },
    disabled:{
      borderBottom:0
    },
    FonTooltip:{
      fontSize: 12
    }
  };
};
export default styles;



// WEBPACK FOOTER //
// ./src/components/LayoutStyle.js